import {$, $$, get, show, hide, getData, gtmSimpleEvent, Key} from '@/Utils';
import {initSearch} from '@/SearchNode';
import {initLogin} from '@/sharedComponents/Header/Login';
import {initDropdowns} from '@/sharedComponents/Dropdown/Dropdown';
import {initCustomerService} from '@/sharedComponents/Header/CustomerService';
import {bindCartPanelDeletes, closePanel, openPanel} from '@/sharedComponents/Panel';
import {initSliders} from '@/CustomSlider.js';
import {GtmEventType} from "@/enums";

function initHeader() {
    $$(".sub-menu__container").forEach(container => {
        const childCount = container.childElementCount;
        Array.from(container.children).forEach(e => e.classList.toggle("grow", childCount < 5));
    });

    $$(".main-nav__item").forEach(elem => {
        elem.addEventListener("click", toggleHeaderMenu);
    });
    document.addEventListener("click", closeOverlay);

    document.addEventListener("keyup", escToClose);
    bindCartPanelDeletes();
    initSliders();

    $$(".sub-menu__mid-level-container").forEach(x => {
        x.addDataBoundEventListener("click", (e: Event) => {
            const activeClass = "sub-menu__block--active";
            const container = (e.currentTarget as HTMLElement).closest(".sub-menu__block");
            const deactivate = container.classList.contains(activeClass);
            $(`.${activeClass}`)?.classList.remove(activeClass);
            if (!deactivate)
                container.classList.add(activeClass);
            if (window.isResponsive)
                container.scrollIntoView({behavior: "smooth"});
        })
    })
    $$(".responsive-panel__back").forEach(x => {
        x.addDataBoundEventListener("click", closeOverlay);
    })

    $(".search").addEventListener("click", toggleResponsiveSearch);
    
    if (get("Home")) {
        $(".autocomplete__wrapper")?.classList.add("visible");
    }
}

function toggleResponsiveSearch() {
    if (window.isResponsive) {
        $(".autocomplete__wrapper")?.classList.toggle("visible");
        const searchInput = get('searchKeyword') as HTMLInputElement;
        searchInput?.focus();
    }
}

function closeOverlay(event: Event) {
    if ($$("#categoryMenu .main-nav__item--active").length) {
        if (!(event.target instanceof Element) || (!window.isResponsive && (event.target as Element).closest(".main-nav"))) return;
        $$(".main-nav__list .main-nav__item--active").forEach(elem => {
            elem.classList.remove("main-nav__item--active")
        });
        hide($(".sub-nav__footer") as HTMLElement);
        $$(".header__overlay.header__overlay--active").forEach(elem => {
            elem.classList.remove("header__overlay--active")
        });
    }
}

function toggleHeaderMenu(this: HTMLElement, event: Event) {

    event.stopPropagation();
    const targetElement = event.target as Element;
    if (targetElement == null) return;
    const closestDiv = targetElement.closest(".nav-item__label");
    if (closestDiv == null) return;
    const footer = $(".sub-nav__footer") as HTMLElement;
    const overlay = $(".header__overlay") as HTMLElement;
    $$(".main-nav__item").forEach(elem => {
        if (this === elem) {
            if (elem.classList.contains("main-nav__item--active")) {
                elem.classList.remove("main-nav__item--active");
                overlay.classList.remove("header__overlay--active");
                hide(footer);
            } else {
                elem.classList.add("main-nav__item--active");
                if (!window.isResponsive) {
                    overlay.classList.add("header__overlay--active");

                }
                show(footer);
                const activeSubmenu = $(".main-nav__item--active .sub-menu") as HTMLElement;
                if (activeSubmenu != null) {
                    footer.style.top = activeSubmenu.clientHeight + "px";
                }
            }
        } else {
            elem.classList.remove("main-nav__item--active");
        }
    });
    return false
}

function escToClose(event: KeyboardEvent) {
    const panelWrapperActive = $(".panel__wrapper--active");
    if (panelWrapperActive) {
        const panel = $(".panel");
        trapFocus(panel as HTMLElement);

    if (event.key === Key.Escape) {
            closePanel();
        }
    }
    const mainNavActive = $(".main-nav__item--active");
  if (mainNavActive && event.key === Key.Escape) {
        mainNavActive.classList.remove("main-nav__item--active");
        $(".header__overlay").classList.remove("header__overlay--active");
        hide($(".sub-nav__footer"));
    }
}

function isOnScreen(element: Element) {
    const curTop = element.scrollTop;
    const screenHeight = (window as any).height;
    return !(curTop > screenHeight || curTop === 0);
}

function trapFocus(element: HTMLElement) {
    let firstFocusableEl: HTMLElement;
    let lastFocusableEl: HTMLElement;
    element.querySelectorAll(
        "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type=\"text\"]:not([disabled]), input[type=\"radio\"]:not([disabled]), input[type=\"checkbox\"]:not([disabled]), select:not([disabled]), h2[tabindex=\"-1\"]")
        .forEach(elem => {
            if (!isOnScreen(elem)) return;
            firstFocusableEl = firstFocusableEl === null ? elem as HTMLElement : firstFocusableEl;
            lastFocusableEl = elem as HTMLElement;
        });

    element.addEventListener("keydown", e => {
    if (e.key !== Key.Tab) {
            return;
        }

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }

    });
}

function initHeaderTabs(initialLoad: boolean) {
    let tab: HTMLElement = null
    if (initialLoad) {
        const selectedMenuId = history.state?.selectedMenuId
        if (selectedMenuId)
            tab = $(`[data-menu-id="${selectedMenuId}"]`)

    }
    if (!tab) {
        const hash = window.location.hash
        if (hash) {
            const elem = $(`[data-hash="${hash}"]`)
            if (elem) {
                closePanel();
                tab = elem
            }
        }
    }
    tab ??= $("[data-header-tab].tabs__item--active")
    activateHeaderTab(tab);

    $$("[data-header-tab]").forEach(x => x.addEventListener("click", () => {
        if (x.hasAttribute("data-tab-url")) {
            location.href = x.getAttribute("data-tab-url");
            return;
        }
        activateHeaderTab(x)
    }))

    function activateHeaderTab(target: HTMLElement) {
        if (!target){
            // Problem - User ends up in a tab that is not visible like /en/news
            // We cannot activate news tab as its not there.
            // Solution: We just take first tab.
            activateHeaderTab(  tab ??= $("[data-header-tab]"))
            return;
        }
        if (!target.classList.contains("tabs__item--active")) {
            const prevTab = $(".tabs__item--active")
            if (prevTab){
                prevTab.classList.remove("tabs__item--active")
                if (prevTab.hasAttribute("data-menu-id"))
                    hide(get(prevTab.getAttribute("data-menu-id")))
            }
            target.classList.add("tabs__item--active")
        }
        const menuId = target.getAttribute("data-menu-id")
        if (menuId) {
            show(get(menuId))
            history.replaceState({selectedMenuId: menuId}, '')
        }
    }
}

function initHashLinks() {
    $$("[data-hash-link]").forEach(x => x.addEventListener("click", () => {
        window.location.href = x.getAttribute("data-hash-link")
        initHeaderTabs(false)
    }))
}

function initFreeLimit() {
    const freeLimit = get("free-limit");
    if (!freeLimit) {
        return;
    }
    getData(window.config.lhvFreeLimit, x => {
        x.text().then(text => freeLimit.textContent = text);
    }, false);
}

function initLangDropdown() {
    const dd = get("language-selector");
    if (dd) {
        initDropdowns();
        dd.addEventListener("valueChange", (event: CustomEvent<HTMLInputElement>) => {
            const callback = () => {
                const url = event.detail.getAttribute("value");
                if(url)
                    window.location.href = url;
            }
            gtmSimpleEvent(GtmEventType.LanguageChange, event.detail.getAttribute("value"), callback);
        });
    }
}

function removePreload() {
    $$(".preload").forEach(x => x.classList.remove("preload"));
}

function initHighlightListener(){
    const elem = get("customer-service-button");
    elem?.addEventListener("click", () => {
        elem.classList.add("highlighted");
    });
}

function conditionalOpenLoginPanel() {
    const urlParams = new URLSearchParams(window.location.search);

    const loginParams = ["login", "prisijungti"];
    const registerParams = ["register", "registreeri", "registruotis", "registreties", "registratsiya"];

    const isLoginPanel = loginParams.some(param => urlParams.has(param));
    const isRegisterPanel = registerParams.some(param => urlParams.has(param));
    const guid = urlParams.get('guid')
    if(!guid && !isLoginPanel && !isRegisterPanel){
        closePanel();
    }

    if (!window.currentUser.IsLoggedIn && (isLoginPanel || isRegisterPanel)) {
        if(isRegisterPanel){
            const registerTab = $('[data-tab-id="register-tab"]') as HTMLElement;
            registerTab.classList.add("tabs-menu__item--active");
            const loginTab = $('[data-tab-id="login-tab"]') as HTMLElement;
            loginTab.classList.remove("tabs-menu__item--active");

        }
        openPanel("login-panel");
    }
}

const initResponsiveBannerSliders = () => {
    if (window.isResponsive) {
        initSliders()
    }
}

window.addEventListener("load", () => {
    initLogin()
    initSearch()
    initCustomerService()
    initFreeLimit()
    initLangDropdown()
    removePreload()
    initHashLinks()
    window.responsiveObserverFunctions = (window.responsiveObserverFunctions || [])
    window.responsiveObserverFunctions.push(initResponsiveBannerSliders)
})

window.addEventListener("DOMContentLoaded", () => {
    initHeader()
    initHeaderTabs(true)
    conditionalOpenLoginPanel()
    initHighlightListener()
})
